export default (
  descriptorFilter, productsById, descriptorsById, descriptorsData,
  productScenarioDescriptors, scenariosById
) => {

  const filteredDescriptors = descriptorsData.filter(v => v.descriptor_type_id === descriptorFilter);
  const filteredDescriptorsIds = filteredDescriptors.map(fD => fD.id);
  const filteredSD = productScenarioDescriptors.filter(fSD => filteredDescriptorsIds.includes(fSD.descriptor_id));

  const mergedProductDescriptors = [];
  const descriptorRepetitions = [];
  filteredSD.forEach(fSD => {
    if (!descriptorRepetitions.includes(fSD.descriptor_id)) {
      const scenariodescriptorGrouped = filteredSD.filter(item => item.descriptor_id === fSD.descriptor_id);
      const mergedDescriptor = {
        id: fSD.descriptor_id,
        descriptor_code: descriptorsById[fSD.descriptor_id].code,
        descriptor_description: descriptorsById[fSD.descriptor_id].description,
        productsInfo: []
      };

      const repeatedProducts = [];
      scenariodescriptorGrouped.forEach(sdg => {
        const product = productsById[scenariosById[sdg.scenario_id].product_id];
        if (!repeatedProducts.includes(product.id)) {
          mergedDescriptor.productsInfo.push({
            code: product.code,
            name: product.name
          });
          repeatedProducts.push(product.id);
        }
      });

      descriptorRepetitions.push(fSD.descriptor_id);
      mergedProductDescriptors.push(mergedDescriptor);
    }
  });

  return mergedProductDescriptors;
};